import { createSlice } from "@reduxjs/toolkit";

export const privacySlice = createSlice({
  name: 'privacy',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startPrivacy: (state) => { state.isLoading = true },
    setPrivacy: (state, { payload: { data, error }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startPrivacy, setPrivacy } = privacySlice.actions;
